// Heros
import ReviewYourResponsesHero from '@/components/credit/hero/ReviewYourResponses.vue';
import ConfirmIDHero from '@/components/credit/hero/ConfirmID.vue';
import CreditScoreHero from '@/components/credit/hero/CreditScore.vue';

// Components
import CreditForm1 from '@/components/credit/CreditForm1.vue';
import CreditForm2 from '@/components/credit/CreditForm2.vue';
import CreditForm2US from '@/components/credit/700Credit/CreditForm2US.vue';
import ReviewForm from '@/components/credit/ReviewForm.vue';
import ReviewFormUS from '@/components/credit/700Credit/ReviewFormUS.vue';
import ConfirmID from '@/components/credit/ConfirmID.vue';
import SocialSecurityNumber from '@/components/SocialSecurityNumber.vue';
import EmployerForm from '@/components/credit/application/EmployerForm.vue';
import MortgageForm from '@/components/credit/application/MortgageForm.vue';
import ThankYou from '@/components/credit/application/ThankYou.vue';
import OtherMonthlyExpenses from '@/components/credit/OtherMonthlyExpenses.vue';
import IncomeAndMortgage from '@/components/credit/IncomeExpenseForm.vue';
import SelectAutoLoan from '@/components/credit/SelectAutoLoan.vue';
import RedirectRoute from '@/components/RedirectEntryRoute.vue';
import ReturningCustomerMobileVerification from '@/components/credit/application/ReturningCustomerMobileVerification.vue';
import MobileVerificationError from '@/components/credit/application/MobileVerificationError.vue';
import ApplicationPreviouslySubmitted from '@/components/credit/application/ApplicationPreviouslySubmitted.vue';
import ApplicationExpired from '@/components/credit/application/ApplicationExpired.vue';
import MobileCodeSender from '@/components/credit/application/MobileCodeSender.vue';

// Views
import CreditResults from '@/views/credit/CreditResults.vue';
import ErrorPage from '@/views/shared/ErrorPageV2.vue';
import EmptyRouterFormView from '@/views/shared/EmptyRouterFormView.vue';
import VehicleDetails from '@/views/credit/VehicleDetails.vue';
import SelectVehicleType from '@/views/credit/SelectVehicleType.vue';
import CreditScoreDetails from '@/views/credit/CreditScoreDetails.vue';

// Routes
import CreditCarfaxTradeIn from '@/components/credit/CreditCarfaxTradeIn.vue';
import CarfaxDetailsForm from '@/components/shared/trade-in-carfax/CarfaxDetailsForm.vue';

export default [
  {
    path: '',
    name: 'credit-desktop',
    component: RedirectRoute,
    meta: {
      skipImpression: true,
    },
  },
  {
    path: 'select-vehicle-type',
    name: 'select-vehicle-type-desktop',
    component: SelectVehicleType,
    meta: {
      headerIcon: 'back',
      currentStep: 0,
    },
  },
  {
    path: 'credit-form',
    component: EmptyRouterFormView,
    meta: { headerIcon: 'back', progressBarType: 'full' },
    children: [
      {
        path: '',
        redirect: { name: 'creditform1-desktop' },
        meta: { showInProgressBar: false },
      },
      // -- Personal information --
      {
        path: 'creditform1',
        name: 'creditform1-desktop',
        components: { default: CreditForm1, usForm: CreditForm1 },
        meta: { showBlocks: true, headerIcon: 'back', parentSection: 'personalInformation' },
      },
      {
        path: 'creditform2',
        name: 'creditform2-desktop',
        components: { default: CreditForm2, usForm: CreditForm2US },
        meta: { showBlocks: true, headerIcon: 'back', parentSection: 'personalInformation' },
      },
      {
        path: 'form-review',
        name: 'form-review-desktop',
        components: { default: ReviewForm, hero: ReviewYourResponsesHero, usForm: ReviewFormUS },
        meta: { showBlocks: true, headerIcon: 'back', parentSection: 'personalInformation' },
      },
      // -- ID Verification --
      {
        path: 'confirm-id',
        name: 'confirm-id-desktop',
        components: { default: ConfirmID, hero: ConfirmIDHero, usForm: ConfirmID },
        meta: { showBlocks: true, parentSection: 'idVerification' },
      },
      // -- Income & debt --
      {
        path: 'income-and-mortgage',
        name: 'income-and-mortgage-desktop',
        component: IncomeAndMortgage,
        meta: { parentSection: 'incomeAndDebt' },
      },
      {
        path: 'other-monthly-expenses',
        name: 'other-monthly-expenses-desktop',
        components: { default: OtherMonthlyExpenses },
        meta: { headerIcon: 'back', parentSection: 'incomeAndDebt' },
      },
      // -- Trade-in --
      {
        path: 'credit-carfax-trade-in',
        name: 'credit-carfax-trade-in-desktop',
        components: { default: CreditCarfaxTradeIn },
        meta: { headerIcon: 'back', parentSection: 'tradeIn' },
      },
      {
        path: ':year/:make/:model/carfax-details-form',
        name: 'credit-carfax-details-form-desktop',
        component: CarfaxDetailsForm,
        meta: { headerIcon: 'back', parentSection: 'tradeIn', basePath: 'carfax-details-form' },
        props: true,
      },
      {
        path: 'select-auto-loan',
        name: 'select-auto-loan-desktop',
        component: SelectAutoLoan,
        meta: { parentSection: 'tradeIn' },
      },
      // -- Results --
      {
        path: 'credit-results',
        name: 'credit-results-desktop',
        components: { default: CreditResults, hero: CreditScoreHero, usForm: CreditResults },
        meta: { headerIcon: 'home', hideCreditHeader: true, parentSection: 'results' },
      },
    ],
  },
  {
    path: 'vehicle-details/:id',
    name: 'vehicle-details-desktop',
    component: VehicleDetails,
    meta: {
      headerIcon: 'back',
      hideCreditHeader: true,
      displayVehicleInfoFooter: true,
    },
  },
  {
    path: 'finance-application',
    name: 'finance-application-desktop',
    redirect: { name: 'employer-form-desktop' },
    meta: { progressBarType: 'flat' },
    components: {
      default: {
        render(h) {
          return h('router-view');
        },
      },
    },
    children: [
      {
        path: 'mobile-code-sender',
        name: 'mobile-code-sender-desktop',
        component: MobileCodeSender,
        meta: {
          headerIcon: false,
        },
      },
      {
        path: 'returning-customer-mobile-verification',
        name: 'returning-customer-mobile-verification-desktop',
        component: ReturningCustomerMobileVerification,
        meta: {
          headerIcon: false,
        },
      },
      {
        path: 'social-security',
        name: 'social-security-desktop',
        component: SocialSecurityNumber,
        meta: {
          displayVehicleNameHeader: true,
          headerIcon: 'back',
        },
      },
      {
        path: 'employer-form',
        name: 'employer-form-desktop',
        component: EmployerForm,
        meta: {
          displayVehicleNameHeader: true,
          headerIcon: 'back',
        },
      },
      {
        path: 'mortgage-form',
        name: 'mortgage-form-desktop',
        component: MortgageForm,
        meta: {
          displayVehicleNameHeader: true,
          headerIcon: 'back',
        },
      },
      {
        path: 'returning-customer-mobile-verification-error',
        name: 'returning-customer-mobile-verification-error-desktop',
        component: MobileVerificationError,
        meta: {
          hideCreditHeader: true,
          headerIcon: 'back',
        },
      },
      {
        path: 'application-previously-submitted',
        name: 'application-previously-submitted-desktop',
        component: ApplicationPreviouslySubmitted,
        meta: {
          hideCreditHeader: true,
          headerIcon: false,
        },
      },
      {
        path: 'application-expired',
        name: 'application-expired-desktop',
        component: ApplicationExpired,
        meta: {
          hideCreditHeader: true,
          headerIcon: false,
        },
      },
      {
        path: 'thank-you',
        name: 'thank-you-desktop',
        components: {
          default: ThankYou,
          usForm: ThankYou,
        },
        meta: {
          hideCreditHeader: true,
          headerIcon: false,
        },
      },
    ],
  },
  {
    path: 'error',
    name: 'credit-in-error-desktop',
    components: {
      default: ErrorPage,
      usForm: ErrorPage,
    },
    meta: {
      headerIcon: 'home',
      hideCreditHeader: true,
      errorPayload: {
        buttonText: 'returnHome',
      },
    },
  },
  {
    path: 'credit-score-details',
    name: 'credit-score-details-desktop',
    component: CreditScoreDetails,
    meta: {
      hideCreditHeader: true,
      headerIcon: 'back',
      hideHeaderCloseButton: true,
    },
  },
];
